// ─────────────────────────────────────────────────────────────
// QUIZ ANALYTICS — Event-Driven Architecture
// Allows future integration with GA, Meta Pixel, GTM, etc.
// ─────────────────────────────────────────────────────────────

const EVENT_TYPES = {
    QUIZ_STARTED: 'quiz_started',
    QUIZ_STEP_COMPLETED: 'quiz_step_completed',
    QUIZ_LEAD_CAPTURED: 'quiz_lead_captured',
    QUIZ_RESULT_VIEWED: 'quiz_result_viewed',
    QUIZ_SHARED: 'quiz_shared',
    QUIZ_ANALYSIS_CLICKED: 'quiz_analysis_clicked',
    QUIZ_ANALYSIS_STARTED: 'quiz_analysis_started',
    QUIZ_ANALYSIS_COMPLETED: 'quiz_analysis_completed',
    QUIZ_ABANDONED: 'quiz_abandoned',
};

/**
 * Queue to hold events before external services are initialized.
 */
const eventQueue = [];

/**
 * Registered listeners (integrations).
 */
const listeners = [];

/**
 * Register an event listener (integration).
 * @param {Function} fn - A function that receives (eventName, eventData)
 */
export function registerAnalyticsListener(fn) {
    listeners.push(fn);
    // Flush queued events to new listener
    eventQueue.forEach(({ name, data }) => fn(name, data));
}

/**
 * Track a quiz event.
 * @param {string} eventName - One of EVENT_TYPES
 * @param {object} eventData - Arbitrary event data
 */
export function trackQuizEvent(eventName, eventData = {}) {
    const enrichedData = {
        ...eventData,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent,
    };

    // Log in dev/console
    if (process.env.NODE_ENV === 'development') {
        console.log(`[QuizAnalytics] ${eventName}`, enrichedData);
    }

    // Dispatch to window for GTM dataLayer
    if (window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...enrichedData,
        });
    }

    // Dispatch to Google Analytics (gtag)
    if (window.gtag) {
        window.gtag('event', eventName, enrichedData);
    }

    // Dispatch to Meta Pixel (fbq)
    if (window.fbq) {
        window.fbq('trackCustom', eventName, enrichedData);
    }

    // Dispatch to registered listeners
    if (listeners.length > 0) {
        listeners.forEach((fn) => fn(eventName, enrichedData));
    } else {
        // Queue for later
        eventQueue.push({ name: eventName, data: enrichedData });
    }
}

export { EVENT_TYPES };
export default { trackQuizEvent, registerAnalyticsListener, EVENT_TYPES };
